import React from "react";
import FooterClasses from "./Footer.module.css";
import Logo from "Assets/logo.png";
import { FaAnglesRight } from "react-icons/fa6";
import { IoLocationOutline } from "react-icons/io5";
import { BiPhoneCall } from "react-icons/bi";
import { TbMail } from "react-icons/tb";
import CustomButton from "Components/Button";
import { NavLink } from "react-router-dom";
import { TiSocialFacebook } from "react-icons/ti";
// import { FaInstagram } from "react-icons/fa";
// import { NavLink } from "react-router-dom";
import { FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

function Footet() {
    return (
        <div className={FooterClasses["wrapper"]}>
            <div className={FooterClasses["Container"]}>
                <div
                    className={`${FooterClasses["about"]} ${FooterClasses["content"]}`}>
                    <img src={Logo} alt="Logo" />
                    <p>
                        At Serene Tax , we specialize in accounting and tax
                        preparation services for a wide array of clients.
                    </p>
                </div>
                <div className={FooterClasses["content"]}>
                    <h3>Quick Links</h3>
                    <NavLink to={"/"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Home
                    </NavLink>
                    <NavLink to={"/about-us"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        About Us
                    </NavLink>
                    <NavLink to={"/Business-tax-returns"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Business returns{" "}
                    </NavLink>
                    <NavLink to={"/Contact"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Contact Us
                    </NavLink>

                    <NavLink to={""}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Login In
                    </NavLink>
                </div>
                <div className={FooterClasses["content"]}>
                    <h3>Services</h3>
                    <NavLink to={"/Advance-tax-planning"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Advance Tax Planning
                    </NavLink>
                    <NavLink to={"/irs-audit-representation"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        IRS Audit representation
                    </NavLink>
                    <NavLink to={"/extension-of-tax-returns"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Extension of Tax Returns
                    </NavLink>
                    <NavLink to={"/payroll-services"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Payroll Service
                    </NavLink>
                    <NavLink to={"/preparation-of-itin"}>
                        <span>
                            <FaAnglesRight />
                        </span>{" "}
                        Preparation of ITIN
                    </NavLink>
                </div>
                <div className={FooterClasses["content"]}>
                    <h3>Get in Touch</h3>
                    <p style={{ maxWidth: "350px" }}>
                        <IoLocationOutline size={40} />
                        42707 WARDLAW TER, Ashburn, Virginia, 20147
                    </p>
                    <p>
                        <BiPhoneCall size={18} />
                        262-735-8875 / 262-735-8875
                    </p>

                    <button
                        onClick={() =>
                            window.open("mailto:support@serenetax.com")
                        }>
                        <TbMail size={18} /> support@serenetax.com{" "}
                    </button>
                </div>
                <div className={FooterClasses["newsletter"]}>
                    <h3>Join Our Newsletter</h3>
                    <div>
                        <input type="text" placeholder="Enter Email" />
                        <CustomButton
                            Title="Submit"
                            onClick={() => { }}
                            Theme="Dark"
                        />
                    </div>
                    <div className={FooterClasses["social"]}>
                        <TiSocialFacebook />
                        <FaInstagram />
                        <FaTwitter />
                        <FaLinkedinIn />
                    </div>
                </div>
            </div>
            <div className={FooterClasses["copyright"]}>
                <p>© Copyright serenetax. All right reserved.</p>
                <div className={FooterClasses["footer_links"]}>
                    <NavLink to={"/refund-policy"}>Refund Policy</NavLink>
                    <p>|</p>
                    <NavLink to={"/terms-conditions"}>
                        Terms and Conditions
                    </NavLink>
                    <p>|</p>
                    {<NavLink to={"/privacy-policy"}>Privacy Policy</NavLink>}
                </div>
            </div>
        </div>
    );
}

export default Footet;
